import { Link } from "wouter";
import { PublicLayout } from "@/components/public/public-layout";
import { Container, Section, PageHero } from "@/components/public/institutional-ui";
import { insights } from "@/lib/site-content";
import { FadeIn } from "@/components/ui/scroll-animations";
import { ArrowRight } from "lucide-react";

export default function InsightsPage() {
  return (
    <PublicLayout>
      <PageHero
        eyebrow="Insights"
        title="News & perspectives"
        description="Debt market reports, financing guides, and outlooks for founders and institutional allocators."
      />

      <Section className="!pt-0">
        <Container>
          <div className="border-t border-border">
            {insights.map((item, i) => (
              <FadeIn key={item.title} delay={i * 0.05}>
                <article className="py-10 md:py-12 border-b border-border flex flex-col md:flex-row md:items-center md:justify-between gap-4 group">
                  <div>
                    <p className="gc-eyebrow text-muted-foreground mb-3">{item.category}</p>
                    <h2 className="text-xl md:text-2xl font-medium max-w-2xl group-hover:opacity-60 transition-opacity">
                      {item.title}
                    </h2>
                  </div>
                  <span className="text-sm text-muted-foreground flex items-center gap-2 shrink-0">
                    {item.date}
                    <ArrowRight className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </span>
                </article>
              </FadeIn>
            ))}
          </div>
          <p className="mt-12 text-sm text-muted-foreground">
            Full articles coming soon.{" "}
            <Link href="/contact">
              <span className="underline underline-offset-4 cursor-pointer hover:opacity-60">
                Contact our team
              </span>
            </Link>{" "}
            for immediate inquiries.
          </p>
        </Container>
      </Section>
    </PublicLayout>
  );
}
